import { render, staticRenderFns } from "./CarouselBasic.vue?vue&type=template&id=382e4776"
import script from "./CarouselBasic.vue?vue&type=script&lang=js"
export * from "./CarouselBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports